var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"banner-wrap one-column-banner"},[_c('div',{staticClass:"container"},[_c('a',{staticClass:"banner",attrs:{"href":_vm.banner.call_to_action_url,"target":_vm.banner.open_in_new_window ? '_blank' : '_self'}},[_c('img',{attrs:{"src":_vm.banner.image.path,"alt":"banner"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }